<!-- <h2 mat-dialog-title></h2> -->

<mat-dialog-content class="dialog-content">
  <div class="close">
    <mat-icon class="closeModal" (click)="close()">close</mat-icon>
  </div>
  <mat-tab-group>
    <mat-tab [label]="data ? 'Editar Temporizador' : 'Crear Temporizador'">
      <form [formGroup]="timerForm" class="formClass row">
        <!-- Nombre del temporizador -->
        <div class="form-group col-12">
          <mat-form-field appearance="outline" class="contentRasSelectorForms">
            <mat-label>Nombre del temporizador</mat-label>
            <input
              matInput
              formControlName="nombre"
              placeholder="Ingrese el nombre"
            />
            <mat-error *ngIf="timerForm.get('nombre').hasError('required')">
              Este campo es obligatorio
            </mat-error>
          </mat-form-field>
        </div>

        <!-- Tipo de alerta -->
        <div class="form-group col-6">
          <mat-form-field appearance="outline" class="">
            <mat-label>Tipo de alerta</mat-label>
            <mat-select formControlName="tipo_alerta">
              <mat-option
                *ngFor="let alerta of alertTypes"
                [value]="alerta.code"
              >
                {{ alerta.valor }}
              </mat-option>
            </mat-select>
            <mat-error
              *ngIf="timerForm.get('tipo_alerta').hasError('required')"
            >
              Este campo es obligatorio
            </mat-error>
          </mat-form-field>
        </div>

        <!-- Unidades -->
        <div class="form-group col-6">
          <mat-form-field appearance="outline" class="">
            <mat-label>Unidades</mat-label>
            <mat-select formControlName="unit">
              <mat-option *ngFor="let unit of units" [value]="unit._id">
                {{ unit.name }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="timerForm.get('unit').hasError('required')">
              Este campo es obligatorio
            </mat-error>
          </mat-form-field>
        </div>

        <!-- Escala de tiempo -->
        <div class="form-group col-6">
          <mat-form-field appearance="outline" class="">
            <mat-label>Escala de tiempo</mat-label>
            <mat-select formControlName="escala">
              <mat-option *ngFor="let escala of timeScales" [value]="escala">
                {{ escala }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="timerForm.get('escala').hasError('required')">
              Este campo es obligatorio
            </mat-error>
          </mat-form-field>
        </div>

        <!-- Valor -->
        <div class="form-group col-6">
          <mat-form-field appearance="outline" class="">
            <mat-label>Valor</mat-label>
            <input
              matInput
              type="number"
              formControlName="valor"
              placeholder="Ingrese el valor"
              min="0"
            />
            <mat-error *ngIf="timerForm.get('valor').hasError('required')">
              Este campo es obligatorio
            </mat-error>
            <mat-error *ngIf="timerForm.get('valor').hasError('min')">
              El valor no puede ser negativo
            </mat-error>
          </mat-form-field>
        </div>
      </form>
    </mat-tab>
  </mat-tab-group>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancelar</button>
  <button
    mat-raised-button
    [disabled]="timerForm.invalid"
    (click)="saveTimer()"
    class="button-create"
  >
    {{ data ? "Actualizar" : "Guardar" }}
  </button>
</mat-dialog-actions>
